var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVkIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 19,
    viewBox: "0 0 30 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3398 19C6.08995 19 0.243598 11.8679 0 0H5.13429C5.30294 8.71071 9.08807 12.4004 12.0862 13.1612V0H16.9207V7.51251C19.8813 7.18919 22.9919 3.76577 24.0412 0H28.8757C28.4803 1.95303 27.6921 3.80224 26.5604 5.43197C25.4287 7.06169 23.9778 8.43686 22.2986 9.47147C24.173 10.4168 25.8286 11.7549 27.1561 13.3974C28.4837 15.0398 29.453 16.9494 30 19H24.6783C24.1873 17.2189 23.1892 15.6245 21.8092 14.4167C20.4292 13.2089 18.7286 12.4413 16.9207 12.2102V19H16.3398Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVkIcon);
export default __webpack_public_path__ + "static/media/VkIcon.b4b623927203e2354bbce8f3037385d4.svg";
export { ForwardRef as ReactComponent };